import { trackBuyflowEvent, trackEvent } from "src/utils/api/tracker";

export const onCompleteLandingPageSurvey = (): void => {
  trackEvent("FinishedLandingPageSurvey");
  trackBuyflowEvent(
    "BuyflowSurveyFinished",
    {
      surveyName: "LandingPageSurvey",
    },
    { blockRoutingToMixpanel: true }
  );
};
